import React, {Component} from 'react'
import {StyleSheet, View, Dimensions, ScrollView, TextInput} from 'react-native'
import {Text, Input, Button} from 'react-native-elements'
import TimePicker from 'rc-time-picker'
import moment from 'moment'
import 'rc-time-picker/assets/index.css'
import {create} from './network'
import InputType from './InputType'

import cloneDeep from 'lodash/cloneDeep'
const VIEW_WIDTH = Dimensions.get('window').width / 1.5
const INPUT_WIDTH = VIEW_WIDTH / 2.5

class TimePoint extends Component {
  constructor (props) {
    super(props)
    this.state = {
      type: this.props.default.type,
      timepoint: this.props.default.timepoint,
      body: this.props.default.body,
    }
  }

  onTimePointChange = text => {
    const value = text.format('HH:mm:ss')
    this.props.data({
      type: this.props.default.type,
      timepoint: value,
      body: this.props.default.body,
    })
  }

  onBodyAndTypeChange = (type, body) => {
    this.props.data({
      type: type,
      timepoint: this.props.default.timepoint,
      body: body,
    })
  }

  onBodyChange = text => {
    this.props.data({
      type: this.props.default.type,
      timepoint: this.props.default.timepoint,
      body: text,
    })
  }

  onTypeChange = type => {
    this.props.data({
      type: type,
      timepoint: this.props.default.timepoint,
      body: this.props.default.body,
    })
  }

  removeTiming = () => {
    this.props.removeTiming()
  }

  getSecondsFromHHMMSS = hms => {
    if (typeof hms !== 'undefined' && hms != null) {
      var a = hms.split(':')

      return moment
        .utc(
          moment
            .duration(+a[0] * 60 * 60 + +a[1] * 60 + +a[2], 'seconds')
            .as('milliseconds'),
        )
        .format('HH:mm:ss')
    } else {
      return moment
        .utc(moment.duration(0, 'seconds').as('milliseconds'))
        .format('HH:mm:ss')
    }
  }

  render () {
    return (
      <View style={styles.timelineViewStyle}>
        <TimePicker
          style={{width: 100}}
          showSecond={true}
          defaultValue={moment()}
          className='xxx'
          onChange={this.onTimePointChange}
          value={moment(this.props.default.timepoint, 'HH:mm:ss')}
        />
        <InputType
          type={this.props.default.type}
          value={this.props.default.body}
          onBodyChange={this.onBodyChange}
          onTypeChange={this.onTypeChange}
          onBodyAndTypeChange={this.onBodyAndTypeChange}
          onSelectFileForTimePoint={this.props.onSelectFileForTimePoint}
        />
        <Button
          icon={{
            name: 'minus',
            size: 15,
            color: 'white',
            type: 'font-awesome-5',
          }}
          buttonStyle={styles.removeButtonStyle}
          onPress={this.removeTiming}
        />
      </View>
    )
  }
}

const styles = StyleSheet.create({
  removeButtonStyle: {backgroundColor: '#b53737', borderRadius: 20},
  timelineViewStyle: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: VIEW_WIDTH,
  },
  inputStyle: {
    width: INPUT_WIDTH,
    margin: 15,
  },
})

export default TimePoint
